module.exports = __webpack_public_path__ + "static/img/writingjapaneseanimal_2_optimized.13551e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/page/writingjapaneseanimal_2_optimized.jpg
// module id = PwGs
// module chunks = 0